import classNames from 'classnames';
import React from 'react';

import { useCustomSelectContext } from './CustomSelectContext';
import type { CustomSelectOptionListProps } from './types';

const CustomSelectOptionList = ({ className, children, inactive = false, ...rest }: CustomSelectOptionListProps) => {
    const { value, id, setListRef, open } = useCustomSelectContext();
    return (
        <ul
            {...rest}
            className={classNames('custom-select__option-list', className, {
                'custom-select__option-list--inactive': inactive,
                'custom-select__option-list--open': open,
            })}
            role="listbox"
            {...(inactive
                ? {}
                : {
                      'aria-activedescendant': value ? `selected-${id}-${String(value)}` : undefined,
                      'aria-labelledby': `custom-select-label-${id}`,
                      tabIndex: -1,
                      ref: setListRef,
                  })}
        >
            {children}
        </ul>
    );
};

export default CustomSelectOptionList;
